<template v-if="true" >
  <div style="height:100%;padding:10px;text-align:center">
    <Steps :current="current" :offset-top="20">
      <Step title="条件筛选"></Step>
      <Step title="选择设备"></Step>
      <Step title="选择操作"></Step>
      <Step title="操作结果"></Step>
    </Steps>

    <div :offset-top="height * 0.15" v-show="showStep1">
      <characteristicStep1 ref="characteristicStep1"></characteristicStep1>
    </div>

    <div :offset-top="height * 0.15" style="height:70%">
      <characteristicStep2 ref="characteristicStep2" v-show="showStep2"></characteristicStep2>
    </div>
    <div :offset-top="height * 0.15" style="height:70%">
      <characteristicStep3 ref="characteristicStep3" v-show="showStep3"></characteristicStep3>
    </div>
    <div :offset-top="height * 0.15" style="height:70%">
      <characteristicStep5
        ref="characteristicStep5"
        v-show="showStep4 && $refs.characteristicStep3.formItem.operatationType == '1'"
      ></characteristicStep5>
    </div>
    <div :offset-top="height * 0.15" style="height:70%">
      <characteristicStep4
        ref="characteristicStep4"
        :result="result"
        :msg="msg"
        v-show="showStep4 && $refs.characteristicStep3.formItem.operatationType == '0'"
        :on-ok="callBackReturn"
      ></characteristicStep4>
    </div>
    <div style="position: fixed; bottom: 10px;right: 10px">
      <Button
        style="margin-right: 10px"
        type="primary"
        @click="pre"
        v-show="(!showStep1&&!showStep4)"
      >上一步</Button>
      <Button
        type="primary"
        @click="pre(true)"
        v-show="showStep4 && this.$refs.characteristicStep3.formItem.operatationType == 1"
      >返回</Button>
      <Button type="primary" @click="next" v-show="!showStep4">下一步</Button>
    </div>
  </div>
</template>
<script>
import characteristicStep1 from "./expand/CharacteristicStep1.vue";
import characteristicStep2 from "./expand/CharacteristicStep2.vue";
import characteristicStep3 from "./expand/CharacteristicStep3.vue";
import characteristicStep5 from "./expand/CharacteristicStep4.vue";
import characteristicStep4 from "./expand/opResult.vue";
export default {
  components: {
    characteristicStep1,
    characteristicStep2,
    characteristicStep3,
    characteristicStep4,
    characteristicStep5
  },
  mounted() {},
  methods: {
    callBackReturn() {
      this.showStep2 = false;
      this.showStep3 = false;
      this.showStep4 = false;
      this.showStep1 = true;
      this.current = 0;
    },
    getMeterId(param) {
      this.meterLabel = param;
    },
    enabledButton(param) {
      if (param == -1) {
        this.disabledTooltip = false;
        this.disabledButtonNext = true;
      } else {
        this.disabledTooltip = true;
        this.disabledButtonNext = false;
      }
    },
    next() {
      if (this.current == 3) {
        // this.current = 0;
      } else {
        if (this.current == 2) {
        }

        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = false;

        this.current += 1;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
          case 1:
            this.showStep2 = true;
            this.viewMeterDetailed[
              "addressLowestLevelAddressIds"
            ] = this.$refs.characteristicStep1.addressDataSelect;
            this.viewMeterDetailed[
              "customerIdcard"
            ] = this.$refs.characteristicStep1.formItem.inputIdCard;
            this.viewMeterDetailed[
              "meterId"
            ] = this.$refs.characteristicStep1.formItem.inputMeterId;
            this.viewMeterDetailed[
              "meterType"
            ] = this.$refs.characteristicStep1.formItem.selectMeterType;
            console.log(this.viewMeterDetailed);
            this.$refs.characteristicStep2.getMeterList(this.viewMeterDetailed);

            break;
          case 2:
            if (this.$refs.characteristicStep2.selectIndex < 0) {
              this.$Message.warning("请选择表具！");
              this.showStep2 = false;
              this.showStep3 = false;
              this.showStep4 = false;
              this.showStep1 = false;
              this.showStep2 = true;
              this.current = 1;
              return;
            }

            this.$refs.characteristicStep3.selectMeter = this.$refs.characteristicStep2.selectMeter;
            console.log(this.$refs.characteristicStep3.selectMeter);

            if (
              this.$refs.characteristicStep3.selectMeter.row.meterTypeName.indexOf(
                "阀"
              ) >= 0
            ) {
              this.$refs.characteristicStep3.formItem.meterType = "1";
            }

            this.showStep3 = true;
            break;
          case 3:
            if (this.$refs.characteristicStep2.selectIndex < 0) {
              this.$Message.warning("请选择表具！");
              this.showStep2 = false;
              this.showStep3 = false;
              this.showStep4 = false;
              this.showStep1 = false;
              this.showStep2 = true;
              this.current = 1;
              return;
            }

            if (
              this.$refs.characteristicStep3.formItem.operatationType == "0"
            ) {
              let resultCode = this.$refs.characteristicStep3.downCharacteristic(
                this.$refs.characteristicStep2.data[
                  this.$refs.characteristicStep2.selectIndex
                ]
              );
              if (resultCode != -1) {
                console.log(resultCode);
                if (resultCode == 0) {
                  this.result = "success";
                  this.msg = "完成下发，点击返回";
                  this.$refs.characteristicStep4.changeStatus(this.result);
                } else {
                  this.result = "fail";
                  this.msg = "下发失败请检查网络";
                  this.$refs.characteristicStep4.changeStatus(this.result);
                }

                this.showStep4 = true;
              }else{
                this.current = 2;
                this.showStep3 = true;
              }
            } else {
              this.showStep4 = true;
              this.$refs.characteristicStep5.getThreshold(
                this.$refs.characteristicStep2.data[
                  this.$refs.characteristicStep2.selectIndex
                ]
              );
              this.$refs.characteristicStep5.getLastCharacteristicCommand(
                this.$refs.characteristicStep2.data[
                  this.$refs.characteristicStep2.selectIndex
                ]
              );
            }

            break;
        }
      }
    },
    pre(isback) {
      if (this.current == 0) {
      } else {
        this.current -= 1;
        this.showStep1 = false;
        this.showStep2 = false;
        this.showStep3 = false;
        this.showStep4 = false;

        switch (this.current) {
          case 0:
            this.showStep1 = true;
            break;
          case 1:
            this.showStep2 = true;
            break;
          case 2:
            if (isback == true) {
              this.current = 0;
              this.showStep1 = true;
            } else {
              this.showStep3 = true;
            }
            break;
          case 3:
            this.showStep4 = true;
            break;
        }
      }
    }
  },
  data() {
    return {
      selectMeter: {},
      height: document.body.clientHeight,
      current: 0,
      disabledButtonNext: false,
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      msg: "",
      result: "",
      viewMeterDetailed: {},
      formItem: {
        selectCondition: "",
        selectMeterType: "",
        inputIdCard: "",
        inputMeterId: ""
      }
    };
  }
};
</script>